import{innerVariant as r}from"./consts.js";var n=function(n){return n in r};export{n as isValidVariant};
//# sourceMappingURL=utils.js.map
